import * as ActionTypes from '../../actions/allActions'
import { affiliatePublicDataNormalizer } from '../../normalizers/Normalizers'

const initialState = {}
const affiliatePublicData = (state = initialState, action) => {
	switch(action.type){
		case ActionTypes.GET_AFFILIATE_PUBLIC_DATA_SUCCESS:
			return affiliatePublicDataNormalizer(action.data.data)
		case ActionTypes.LOGOUT:
			return initialState
		default:
			return state
	}
}

export default affiliatePublicData



// WEBPACK FOOTER //
// ./src/reducers/data/affiliatePublicData.js